import { render, staticRenderFns } from "./CountryObjectAvatar.vue?vue&type=template&id=b4e7239a&scoped=true"
import script from "./CountryObjectAvatar.vue?vue&type=script&lang=js"
export * from "./CountryObjectAvatar.vue?vue&type=script&lang=js"
import style0 from "./CountryObjectAvatar.vue?vue&type=style&index=0&id=b4e7239a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e7239a",
  null
  
)

export default component.exports